import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';
import { Input } from '@/shared/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select';
import type { FormStatus, FormsFilters } from '../../types';

const STATUS_OPTIONS: FormStatus[] = ['Draft', 'Shared', 'Closed', 'Archived'];

interface FormsListFiltersProps {
  filters: FormsFilters;
  onChange: (filters: FormsFilters) => void;
}

export function FormsListFilters({ filters, onChange }: FormsListFiltersProps) {
  const { t } = useTranslation('forms');

  return (
    <div className="flex flex-col gap-2 md:flex-row md:items-center">
      <div className="relative w-full md:w-64">
        <Search className="absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          className="pl-8"
          placeholder={t('list.searchPlaceholder')}
          value={filters.searchTerm ?? ''}
          onChange={(e) => onChange({ ...filters, searchTerm: e.target.value })}
          data-testid="forms-list-search-input"
        />
      </div>

      <Select
        value={filters.status ?? 'all'}
        onValueChange={(value) =>
          onChange({ ...filters, status: value === 'all' ? undefined : (value as FormStatus) })
        }
      >
        <SelectTrigger className="w-full md:w-48" data-testid="forms-list-status-filter">
          <SelectValue placeholder={t('list.filters.allStatuses')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t('list.filters.allStatuses')}</SelectItem>
          {STATUS_OPTIONS.map((status) => (
            <SelectItem key={status} value={status}>
              {t(`status.${status.toLowerCase()}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
